import 'swiper/css/pagination';

import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { forwardRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { nestleGroupLink, nestlePetsCardList, nestlePetsMobileCardList } from 'reactApp/appHelpers/featuresHelpers/features/nestle';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { Button } from 'reactApp/sections/Nestle/Button/Button';
import {
    sendNestleLandingAnalytics,
    sendNestleLandingSnitch,
    sendNestleLandingTmrGoal,
} from 'reactApp/sections/Nestle/NestleLanding.analytics';
import { Title } from 'reactApp/sections/Nestle/Title/Title';
import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './PetsCardCarousel.css';

export const PetsCardCarousel = forwardRef<HTMLDivElement | null>((_, ref) => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    const onButtonClick = useCallback(() => {
        sendNestleLandingTmrGoal('follow-updates-button');
        sendNestleLandingSnitch('openGroup');
        sendNestleLandingAnalytics({
            eventCategory: 'click',
            action: 'follow-updates-button',
        });
    }, []);

    const list = isMobile ? nestlePetsMobileCardList : nestlePetsCardList;

    if (!list) {
        return null;
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_mobile]: isMobile,
            })}
            ref={ref}
        >
            <Title
                title={
                    <>
                        карточки пушистиков&nbsp;— только
                        <br />
                        посмотрите на эти усы
                    </>
                }
            />
            <Spacing size={isMobile ? 12 : 50} />
            <div>
                <Swiper
                    slidesPerView={'auto'}
                    centeredSlides
                    loop
                    pagination={{
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 3,
                    }}
                    autoplay={{
                        delay: 3500,
                        disableOnInteraction: false,
                    }}
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={isMobile ? 12 : 0}
                >
                    {list.map((item, index) => (
                        <SwiperSlide key={`pet-${index}`} className={styles.slide}>
                            <img src={item} className={styles.petSlide} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {nestleGroupLink && (
                <>
                    <Spacing size={isMobile ? 2 : 20} />
                    <div className={styles.button}>
                        <Button text="Следить за перекличкой в группе Mail" href={nestleGroupLink} onClick={onButtonClick} />
                    </div>
                </>
            )}

            <Spacing size={isMobile ? 24 : 80} />
        </div>
    );
});

PetsCardCarousel.displayName = 'PetsCardCarousel';
